import { store} from '@/store/store';
import { UtilsString } from '@/utils/utils-string';
import { getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';

@Module({
  namespaced: true,
  name: 'PublicPathModule',
  store,
  dynamic: true,
})
class PublicPathModule extends VuexModule {

  public publicPath: string = UtilsString.Empty;

  @Mutation
  public setPublicPath(publicPath: string) {
    this.publicPath = publicPath;
  }

}

export default getModule(PublicPathModule);
